<template>
  <div v-if="value === true">Ano</div>
  <div v-else-if="value === false">Ne</div>
  <div v-else>-</div>
</template>

<script>
export default {
  name: 'YesNo',
  props: {
    value: {
      type: Boolean,
      required: false,
    },
  },
}
</script>
